var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"mt-1",attrs:{"hide-details":"","light":""},on:{"change":function($event){return _vm.onChanged()}},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }